import { useNavigate } from "react-router-dom";
import { browserSessionStorage, lastCrewSurface } from "../lib/crewContinuity";
import { crewSurfacePath } from "../lib/routes";
import { formatAge } from "../lib/time";
import { useRemote } from "../state/RemoteContext";

export function CrewsScreen() {
  const { fixture } = useRemote();
  const navigate = useNavigate();
  return (
    <div className="screen">
      <header className="screen-heading">
        <span className="eyebrow">Exposed by {fixture.session.hostLabel}</span>
        <h1>Crews</h1>
        <p>{fixture.crews.length === 0 ? "No Crew control loops are exposed to this session." : `${fixture.crews.length} independent control loop${fixture.crews.length === 1 ? "" : "s"}, one ranked remote view.`}</p>
      </header>
      <div className="crew-index">
        {fixture.crews.map((crew) => (
          <button
            type="button"
            className="crew-row"
            key={crew.id}
            onClick={() => navigate(crewSurfacePath(
              crew.id,
              lastCrewSurface(browserSessionStorage(), fixture.session.sessionId, crew.id),
            ))}
          >
            <span className="health-dot" data-health={crew.health} aria-hidden="true" />
            <span className="crew-row__body">
              <strong>{crew.name}</strong>
              <small>{crew.runState}{crew.since.decisionCount ? ` · ${crew.since.decisionCount} decision` : crew.health === "at-risk" ? " · at risk" : ""}</small>
              <span>{crew.summary}</span>
            </span>
            <span className="crew-row__age">{formatAge(crew.members[0].lastBeatAt)}</span>
            <span aria-hidden="true">›</span>
          </button>
        ))}
      </div>
    </div>
  );
}
